module.exports = __webpack_public_path__ + "static/media/gif2.d68c87cb.gif";